var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SidbearSettingsGroup',{attrs:{"title":"Card Settings","active":""}},[(_vm.linked)?_c('b-form-group',[_c('button',{staticClass:"flex p-0 text-[11px] hover:bg-gray-100 items-center text-dark border rounded-[4px] w-[114px] h-[30px] justify-content-center gap-[5px] cursor-pointer font-[500] hover:text-[#3D82EA] text-[#7E7E7E]",on:{"click":() => _vm.unlinkSid()}},[_vm._v(" Unlink Styles "),_c('i',{staticClass:"fa fa-link text-primary"})])]):_vm._e(),_c('b-form-group',[_c('b-checkbox',{attrs:{"switch":""},model:{value:(_vm.section.options.content.flipCard.active),callback:function ($$v) {_vm.$set(_vm.section.options.content.flipCard, "active", $$v)},expression:"section.options.content.flipCard.active"}},[_c('div',{staticClass:"mt-1"},[_vm._v(" Flip to Edit Front/Back ")])])],1),(_vm.section.options.content.flipCard.direction)?_c('b-form-group',{attrs:{"label":"Flip Direction"}},[_c('v-select',{staticClass:"custom-select",attrs:{"reduce":val => val.key,"options":_vm.variants,"searchable":false,"append-to-body":""},model:{value:(_vm.section.options.content.flipCard.direction[_vm.resolutioner]),callback:function ($$v) {_vm.$set(_vm.section.options.content.flipCard.direction, _vm.resolutioner, $$v)},expression:"section.options.content.flipCard.direction[resolutioner]"}})],1):_vm._e(),_c('b-form-group',[_c('sid-range-slider',{attrs:{"rule-name":"width","sid":`.--${_vm.section.sid}--card`,"default-dimension":"%","dimensions":['%', 'vw', 'px'],"label":"Width","var":"--width","measurement":"width"}})],1),_c('sid-range-slider',{attrs:{"rule-name":"height","sid":`.--${_vm.section.sid}--card`,"default-dimension":"px","dimensions":['px', 'vh'],"label":"Height","var":"--height","reset-value":"300px","measurement":"height"}}),_c('sid-buttons-group',{attrs:{"label":"Vertical Content Alignment","options":[
        {
          svg: 'data:image/svg+xml,%3Csvg width=\'16\' height=\'10\' viewBox=\'0 0 16 10\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect x=\'2.54688\' y=\'1.59863\' width=\'4.1387\' height=\'7.67361\' fill=\'%237E7E7E\'/%3E%3Crect x=\'7.32251\' y=\'1.59863\' width=\'4.1387\' height=\'5.43547\' fill=\'%237E7E7E\'/%3E%3Crect width=\'15.2814\' height=\'0.959201\' transform=\'matrix(1 0 0 -1 0 0.958984)\' fill=\'%237E7E7E\'/%3E%3C/svg%3E%0A',
          value: 'start',
          tooltip: 'Start'
        },
        {
          svg: 'data:image/svg+xml,%3Csvg width=\'16\' height=\'9\' viewBox=\'0 0 16 9\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect x=\'2.87305\' y=\'0.349243\' width=\'4.05866\' height=\'8.46585\' fill=\'%237E7E7E\'/%3E%3Crect x=\'7.55664\' y=\'0.976318\' width=\'4.05866\' height=\'6.8981\' fill=\'%237E7E7E\'/%3E%3Crect width=\'14.9858\' height=\'0.94065\' transform=\'matrix(1 0 0 -1 0.0634766 5.05249)\' fill=\'%237E7E7E\'/%3E%3C/svg%3E%0A',
          value: 'center',
          tooltip: 'Center'
        },
        {
          svg: 'data:image/svg+xml,%3Csvg width=\'16\' height=\'10\' viewBox=\'0 0 16 10\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect width=\'4.0532\' height=\'7.51508\' transform=\'matrix(1 -8.77996e-08 -8.70476e-08 -1 3.43945 7.86438)\' fill=\'%237E7E7E\'/%3E%3Crect width=\'4.0532\' height=\'5.32318\' transform=\'matrix(1 -8.77996e-08 -8.70476e-08 -1 8.11523 7.86438)\' fill=\'%237E7E7E\'/%3E%3Crect width=\'14.9657\' height=\'0.939385\' transform=\'matrix(1 0 0 -1 0.632812 9.43018)\' fill=\'%237E7E7E\'/%3E%3C/svg%3E%0A',
          value: 'end',
          tooltip: 'End'
        }
      ],"sid":`.--${_vm.section.sid}--card ${_vm.currentSideSid}`,"rule-name":"align-items"}}),_c('sid-buttons-group',{attrs:{"label":"Horizontal Alignment","options":[
        {
          svg: 'data:image/svg+xml,%3Csvg width=\'11\' height=\'15\' viewBox=\'0 0 11 15\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect x=\'10.04\' y=\'10.9219\' width=\'3.94211\' height=\'7.30912\' transform=\'rotate(180 10.04 10.9219)\' fill=\'%237E7E7E\'/%3E%3Crect x=\'5.54224\' y=\'10.9219\' width=\'3.94211\' height=\'7.30912\' transform=\'rotate(180 5.54224 10.9219)\' fill=\'%237E7E7E\'/%3E%3Crect width=\'14.5555\' height=\'0.91364\' transform=\'matrix(-4.37114e-08 -1 -1 4.37114e-08 0.913574 14.5557)\' fill=\'%237E7E7E\'/%3E%3C/svg%3E%0A',
          value: 'start',
          tooltip: 'Start'
        },
        {
          svg: 'data:image/svg+xml,%3Csvg width=\'11\' height=\'15\' viewBox=\'0 0 11 15\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect x=\'3.9668\' y=\'11.2344\' width=\'3.96671\' height=\'7.35473\' transform=\'rotate(180 3.9668 11.2344)\' fill=\'%237E7E7E\'/%3E%3Crect x=\'10.4326\' y=\'11.2344\' width=\'3.96671\' height=\'7.35473\' transform=\'rotate(180 10.4326 11.2344)\' fill=\'%237E7E7E\'/%3E%3Crect width=\'14.3631\' height=\'0.901561\' transform=\'matrix(-4.37114e-08 -1 -1 4.37114e-08 5.59766 14.363)\' fill=\'%237E7E7E\'/%3E%3C/svg%3E%0A',
          value: 'center',
          tooltip: 'Center'
        },
        {
          svg: 'data:image/svg+xml,%3Csvg width=\'11\' height=\'16\' viewBox=\'0 0 11 16\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect width=\'4.1188\' height=\'7.63672\' transform=\'matrix(1 8.74228e-08 8.74228e-08 -1 0 12.2031)\' fill=\'%237E7E7E\'/%3E%3Crect width=\'4.1188\' height=\'7.63672\' transform=\'matrix(1 8.74228e-08 8.74228e-08 -1 4.7002 12.2031)\' fill=\'%237E7E7E\'/%3E%3Crect x=\'9.53613\' y=\'16\' width=\'15.2079\' height=\'0.95459\' transform=\'rotate(-90 9.53613 16)\' fill=\'%237E7E7E\'/%3E%3C/svg%3E%0A',
          value: 'end',
          tooltip: 'End'
        }
      ],"sid":`.--${_vm.section.sid}--card ${_vm.currentSideSid}`,"rule-name":"justify-content"}})],1),_vm._l(([{key: 'front', label: 'Front'}, {key: 'back', label: 'Back'}]),function(n){return _c('div',{key:n.key},[_c('SidbearSettingsGroup',{attrs:{"title":`${n.label} Side`}},[_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}--card .es_card-content`,"rule-name":"border-style","searchable":false,"options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}--card .es_card-content`,"label":"Border Width","rule-name":"border","css-var":"--border-size","angles":[
            {
              text: '',
              value: 'top-width'
            },
            {
              text: '',
              value: 'right-width'
            },
            {
              text: '',
              value: 'bottom-width'
            },
            {
              text: '',
              value: 'left-width'
            }
          ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--card .es_card-content`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.section.sid}--card .es_card-content`,"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
          {
            text: '',
            value: 'top-left-radius',
            cssVar: '--border-top-left-radius'
          },
          {
            text: '',
            value: 'top-right-radius',
            cssVar: '--border-top-right-radius'
          },
          {
            text: '',
            value: 'bottom-left-radius',
            cssVar: '--border-bottom-left-radius'
          },
          {
            text: '',
            value: 'bottom-right-radius',
            cssVar: '--border-bottom-right-radius'
          }
        ]}}),_c('b-form-group',{attrs:{"label":"Shadow Color"}},[_c('sid-box-shadow',{attrs:{"sid":`.--${_vm.section.sid}--card .es_card-${n.key}`,"rule-name":"box-shadow"}})],1),_c('sid-linked-group',{attrs:{"label":"Padding","sid":`.--${_vm.section.sid}--card .es_card-${n.key}`,"rule-name":"padding","min":0,"angles":[
          {
            text: '',
            value: 'top'
          },
          {
            text: '',
            value: 'right'
          },
          {
            text: '',
            value: 'bottom'
          },
          {
            text: '',
            value: 'left'
          }
        ]}})],1),_c('SidbearSettingsGroup',{attrs:{"title":`${n.label} Side Background`}},[_c('sid-background',{staticClass:"mb-0",attrs:{"sid":`.--${_vm.section.sid}--card .es_card-${n.key}`}}),_c('sid-upload-image',{attrs:{"sid":`.--${_vm.section.sid}--card .es_card-${n.key} .block-bg`,"rule-name":"background-image"}}),_c('b-form-group',{attrs:{"label":"Background Image Size"}},[_c('sid-select',{attrs:{"priority":"","searchable":false,"options":[
            {
              label: 'Normal',
              value: '',
              customProperties: [[`.--${_vm.section.sid}--card .es_card-${n.key} > .block-bg`, ['background-attachment', 'unset']]]
            },
            {
              label: 'Full Center (Parallax)',
              value: 'fixed',
              customProperties: [[`.--${_vm.section.sid}--card .es_card-${n.key} > .block-bg`, ['background-size', 'cover']], [`.--${_vm.section.sid}--card .es_card-${n.key} > .block-bg`, ['background-attachment', 'fixed']]]
            },
            {
              label: 'Fill 100 % Width',
              value: '100% auto',
              customProperties: [[`.--${_vm.section.sid}--card .es_card-${n.key} > .block-bg`, ['background-attachment', 'unset']]]
            },
            {
              label: 'Fill 100 % Width & Height',
              value: '100% 100%',
              customProperties: [[`.--${_vm.section.sid}--card .es_card-${n.key} > .block-bg`, ['background-attachment', 'unset']]]
            },
            {
              label: 'Repeat',
              value: 'repeat',
              property: 'background-repeat',
              customProperties: [[`.--${_vm.section.sid}--card .es_card-${n.key} > .block-bg`, ['background-size', 'contain']], [`.--${_vm.section.sid}--card .es_card-${n.key} > .block-bg`, ['background-repeat', 'repeat']], [`.--${_vm.section.sid}--card .es_card-${n.key} > .block-bg`, ['background-attachment', 'unset']]]
            },
            {
              label: 'Repeat Horizontally',
              value: 'repeat-x',
              property: 'background-repeat',
              customProperties: [[`.--${_vm.section.sid}--card .es_card-${n.key} > .block-bg`, ['background-size', 'contain']], [`.--${_vm.section.sid}--card .es_card-${n.key} > .block-bg`, ['background-repeat', 'repeat-x']], [`.--${_vm.section.sid}--card .es_card-${n.key} > .block-bg`, ['background-attachment', 'unset']]]
            },
            {
              label: 'Repeat Vertically',
              value: 'repeat-y',
              property: 'background-repeat',
              customProperties: [[`.--${_vm.section.sid}--card .es_card-${n.key} > .block-bg`, ['background-size', 'contain']], [`.--${_vm.section.sid}--card .es_card-${n.key} > .block-bg`, ['background-repeat', 'repeat-y']], [`.--${_vm.section.sid}--card .es_card-${n.key} > .block-bg`, ['background-attachment', 'unset']]]
            },
            {
              label: 'Cover',
              value: 'cover',
              customProperties: [[`.--${_vm.section.sid}--card .es_card-${n.key} > .block-bg`, ['background-size', 'cover']], [`.--${_vm.section.sid}--card .es_card-${n.key} > .block-bg`, ['background-attachment', 'unset']]]
            },
            {
              label: 'Contain',
              value: 'contain',
              customProperties: [[`.--${_vm.section.sid}--card .es_card-${n.key} > .block-bg`, ['background-size', 'contain']], [`.--${_vm.section.sid}--card .es_card-${n.key} > .block-bg`, ['background-attachment', 'unset']]]
            }
          ],"sid":`.--${_vm.section.sid}--card .es_card-${n.key} > .block-bg`,"var":"--background-size","rule-name":"background-size"}})],1),_c('b-form-group',{attrs:{"label":"Background Image Position"}},[_c('sid-select',{attrs:{"searchable":false,"options":[
            {label: 'Left Top', value: 'left top'},
            {label: 'Left Center', value: 'left center'},
            {label: 'Left Bottom', value: 'left bottom'},
            {label: 'Right Top', value: 'right top'},
            {label: 'Right Center', value: 'right center'},
            {label: 'Right Bottom', value: 'right bottom'},
            {label: 'Center Top', value: 'center top'},
            {label: 'Center Center', value: 'center center'},
            {label: 'Center Bottom', value: 'center bottom'},
          ],"sid":`.--${_vm.section.sid}--card .es_card-${n.key} > .block-bg`,"rule-name":"background-position"}})],1),_c('sid-range-slider',{attrs:{"sid":`.--${_vm.section.sid}--card .es_card-${n.key} > .block-bg`,"label":"Custom Size","rule-name":"background-size","var":"--custom-bg-size","unlim":"","dimensions":['px', '%', 'vh', 'vw']}}),_c('b-form-group',{attrs:{"label":"Transform-Y"}},[_c('sid-range-slider',{attrs:{"sid":`.--${_vm.section.sid}--card .es_card-${n.key} > .block-bg`,"rule-name":"background-position-y"}})],1),_c('b-form-group',{attrs:{"label":"Transform-X"}},[_c('sid-range-slider',{attrs:{"sid":`.--${_vm.section.sid}--card .es_card-${n.key} > .block-bg`,"rule-name":"background-position-X"}})],1),_c('sid-overlay',{attrs:{"sid":`.--${_vm.section.sid}--card .es_card-${n.key} > .block-bg + .el-overlay`,"rule-name":""}}),_c('hr'),_c('sid-background-filters',{attrs:{"sid":`.--${_vm.section.sid}--card .es_card-${n.key} > .block-bg`,"rule-name":"filter"}}),_c('b-form-group',[_c('sid-range-slider',{attrs:{"label":"Opacity","rule-name":"opacity","dimensions":[],"default-dimension":"","sid":`.--${_vm.section.sid}--card .es_card-${n.key} > .block-bg`,"min":0,"max":1,"step":0.1}})],1)],1)],1)}),_c('SidbearSettingsGroup',{attrs:{"title":"Border & Radius"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}--card .es_card-content`,"rule-name":"border-style","searchable":false,"options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}--card .es_card-content`,"label":"Border Width","rule-name":"border","css-var":"--border-size","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--card .es_card-content`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.section.sid}--card .es_card-content`,"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
            {
              text: '',
              value: 'top-left-radius',
              cssVar: '--border-top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius',
              cssVar: '--border-top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius',
              cssVar: '--border-bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius',
              cssVar: '--border-bottom-right-radius'
            }
          ]}})]},proxy:true},{key:"Hover",fn:function(){return [_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}--card .es_card-content`,"rule-name":"border-style","searchable":false,"presudo":":hover","options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}--card .es_card-content`,"label":"Border Width","rule-name":"border","css-var":"--border-size","presudo":":hover","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--card .es_card-content`,"rule-name":"border-color","presudo":":hover"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.section.sid}--card .es_card-content`,"rule-name":"border","presudo":":hover","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
            {
              text: '',
              value: 'top-left-radius',
              cssVar: '--border-top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius',
              cssVar: '--border-top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius',
              cssVar: '--border-bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius',
              cssVar: '--border-bottom-right-radius'
            }
          ]}})]},proxy:true}])})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Drop Shadow"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Shadow Color"}},[_c('sid-box-shadow',{attrs:{"sid":`.--${_vm.section.sid}--card .es_card-content`,"rule-name":"box-shadow"}})],1)]},proxy:true},{key:"Hover",fn:function(){return [_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Shadow Color"}},[_c('sid-box-shadow',{attrs:{"sid":`.--${_vm.section.sid}--card .es_card-content`,"presudo":":hover","rule-name":"box-shadow"}})],1)]},proxy:true}])})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Padding & Margins"}},[_c('sid-linked-group',{attrs:{"label":"Padding","sid":`.--${_vm.section.sid}--card .es_card-content`,"rule-name":"padding","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}}),_c('sid-linked-group',{attrs:{"label":"Margin","sid":`.--${_vm.section.sid}--card`,"rule-name":"margin","min":-2000,"max":2000,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }